import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, TextField, Button, Alert, Card, CardContent } from '@mui/material';
import ResetBgImg from "assets/img/reset_password.png";
// import { resetUserPassword, resetSelfPassword } from ''; 
// import { digestMessage } from '../../common_utils/utils';
import { validateEmail } from '../../common_utils/utils';
import { resetPassword } from 'apis/CustomersApis';

import typography from "assets/mavric-theme/base/typography";
import colors from "assets/mavric-theme/base/colors";
import Box from '@mui/material/Box';
import { digestMessage } from 'common_utils/utils';

const { size } = typography;
const { primary, secondary, text } = colors;

export default function ResetPassword({ bizUsrInfo, ruid, UserReset, formAction, inProcess }) {
    const dispatch = useDispatch();
    const StateMsgError = useSelector(state => state.error);
    const isStateError = useSelector(state => state.isError);
    const isStateSuccess = useSelector(state => state.isSuccess);
    const StateMsgSuccess = useSelector(state => state.successMsg);
    const sUserId = useSelector(state => state.userid);

    const initialUserInfo = { email: null, role: '', role_id: 3 };
    const [userInfo, setUserInfo] = useState(bizUsrInfo || initialUserInfo);
    const [usrEmail, setEmailAddr] = useState(userInfo.email || '');
    const [curPassword, setCurPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confPassword, setConfPassword] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [pageAlertType, setPageAlertType] = useState("error");
    const [pageAlertMsg, setPageAlertMsg] = useState("");
    const [isProc, setIsProc] = useState(inProcess || false);

    useEffect(() => {
        let timer;
        if (showAlert) {
            timer = setTimeout(() => {
                setShowAlert(false);
            }, 5000);
        }
        return () => clearTimeout(timer);
    }, [showAlert]);

    useEffect(() => {
        if (isProc) {
            if (isStateSuccess) setSuccessAlert(StateMsgSuccess);
            if (isStateError) setErrorAlert(StateMsgError.includes("Invalid password") ? "Invalid password provided" : StateMsgError);
        }
    }, [isStateError, StateMsgError, isStateSuccess, StateMsgSuccess, isProc]);

    const setErrorAlert = (msg) => {
        setPageAlertType("error");
        setShowAlert(true);
        setPageAlertMsg(msg);
    };

    const setSuccessAlert = (msg) => {
        setPageAlertType("success");
        setShowAlert(true);
        setPageAlertMsg(msg);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!curPassword || !newPassword || !confPassword) {
            setErrorAlert("All fields are required");
            return;
        }

        if (newPassword !== confPassword) {
            setErrorAlert("Passwords do not match");
            return;
        }
        let hashedNewPwd, hashedCurrentPwd;

        try {
            hashedNewPwd = await digestMessage(newPassword);
            hashedCurrentPwd = await digestMessage(curPassword);
            if (!hashedNewPwd || !hashedCurrentPwd) {
                throw new Error("Failed to hash passwords");
            }
            // const response = await resetPassword(newPassword, curPassword);
            const response = await resetPassword(hashedNewPwd, hashedCurrentPwd);
            console.log("Password reset successfully:", response);
            setSuccessAlert("Successfully updated password");
        } catch (error) {
            console.error("Error resetting password:", error);
            setErrorAlert("Error resetting password. Please try again.");
        } finally {
            hashedNewPwd = null;
            hashedCurrentPwd = null;
        }
    };

    return (
        <Grid container direction="column" justifyContent="start" alignItems="start">
            <Grid item>
                <Card>
                    <CardContent>
                        <form onSubmit={handleSubmit}>
                            <Grid container direction="column" spacing={2} justifyContent="center" alignItems="center">
                                <Grid item>
                                    <Box
                                        component="img"
                                        alt="Wohler Logo"
                                        src={ResetBgImg}
                                        justifyContent="center"
                                        sx={{ width: 150, height: "auto" }}
                                    />
                                </Grid>

                                <Grid item>
                                    {UserReset ? (
                                        <>
                                            <Typography fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 600 }}>
                                                Email Address
                                            </Typography>
                                            <TextField
                                                sx={{ width: 300, color: "#E5E5E5" }}
                                                error={!validateEmail(usrEmail)}
                                                required
                                                id='usrEmail'
                                                name='usrEmail'
                                                placeholder="xyz@company.com"
                                                value={usrEmail}
                                                onChange={(e) => setEmailAddr(e.target.value)}
                                                variant="outlined"
                                                autoComplete="given-name"
                                                InputProps={{
                                                    readOnly: true,
                                                    color: "#E5E5E5"
                                                }}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <Typography fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 600 }}>
                                                Current Password
                                            </Typography>
                                            <TextField
                                                sx={{ width: 300 }}
                                                id="filled-password-input"
                                                type="password"
                                                value={curPassword}
                                                onChange={(e) => setCurPassword(e.target.value)}
                                                placeholder="Current Password"
                                                variant="outlined"
                                            />
                                        </>
                                    )}
                                </Grid>

                                <Grid item>
                                    <Typography fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 600 }}>
                                        New Password
                                    </Typography>
                                    <TextField
                                        sx={{ width: 300 }}
                                        id="filled-password-input"
                                        type="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        placeholder="New Password"
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item>
                                    <Typography fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 600 }}>
                                        Confirm Password
                                    </Typography>
                                    <TextField
                                        sx={{ width: 300 }}
                                        id="filled-password-input"
                                        type="password"
                                        value={confPassword}
                                        onChange={(e) => setConfPassword(e.target.value)}
                                        placeholder="Confirm Password"
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item>
                                    <Button type="submit" variant="contained" color="secondary">
                                        Reset Password
                                    </Button>
                                </Grid>

                                <Grid item>
                                    {showAlert && (
                                        <Alert variant="filled" severity={pageAlertType} onClick={() => setShowAlert(false)} sx={{ py: 0 }}>
                                            <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                                                {pageAlertMsg}
                                            </Typography>
                                        </Alert>
                                    )}
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}
